import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=5dd12bcc&scoped=true"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"
import style0 from "./CopyText.vue?vue&type=style&index=0&id=5dd12bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd12bcc",
  null
  
)

export default component.exports